import raw from "@/data/news.json";

export type NewsItem = {
  id: string;
  title: string;
  Reference: string;
  "Reference website": string;
  image: string;
  content: string;
  excerpt: string;
  wordCount: number;
};

export const news = raw as NewsItem[];

export function getNews(id: string): NewsItem | undefined {
  return news.find((n) => n.id === id);
}

// Estimate a reading time
export function readingTime(words: number): number {
  return Math.max(4, Math.round(words / 220));
}

// Deterministic pseudo-category based on title keywords
export function categoryOf(title: string): string {
  const t = title.toLowerCase();
  if (t.includes("world cup") || t.includes("final") || t.includes("semi") || t.includes("quarter") || t.includes("round of")) return "World Cup 2026";
  if (t.includes("qualifier")) return "Qualifiers";
  if (t.includes("nations league")) return "UEFA Nations League";
  if (t.includes("friendly") || t.includes("showcase") || t.includes("exhibition")) return "International";
  return "Football";
}

// Deterministic hours-ago for freshness display
export function hoursAgo(id: string): number {
  let h = 0;
  for (const c of id) h = (h * 31 + c.charCodeAt(0)) % 96;
  return h + 1;
}
